import React, { useState, useEffect, useContext } from "react";
// import axios from "axios";
import { BentoCard } from "Components/uiElements/UIComponents/bento-grid/bento-grid";
import "./TourListIframe.css";
import {
  GridContainer,
  scrollToTop,
  SkeletonTourListPreload,
} from "MainApp/assets/visual/styles/globalStyles/globalJsxStyles";
import { ToursContext } from "MainApp/assets/utils/context/TourContext";
import { slugify } from "MainApp/assets/utils/js/slugyfy";
import { AuthContext } from "MainApp/assets/utils/context/AuthContext";

function TourListIframe() {
  const { tours, setTours, setLoading } = useContext(ToursContext);
  const getListUrl = "/toursAPI/get-list";
  const { token, axiosInstance, isAuthReady, realToken } =
    useContext(AuthContext);
  useEffect(() => {
    console.log("👉 axiosInstance en TourList:", axiosInstance);
    if (axiosInstance) {
      console.log("👉 Tipo de axiosInstance.get:", typeof axiosInstance.get);
    }
  }, [axiosInstance]);
  useEffect(() => {
    console.log("TourList useEffect ->", {
      toursLength: tours.length,
      isAuthReady,
      token,
      axiosInstance,
    });
    if (tours.length === 0 && isAuthReady && token && axiosInstance) {
      console.log("inside!");
      console.log("VALUE ", token);

      axiosInstance
        .get(getListUrl)
        .then((response) => {
          console.log("then");
          if (response.data && Array.isArray(response.data.tours)) {
            console.log("Tours fetched successfully:", response.data.tours);
            const transformedTours = response.data.tours.map((tour) => {
              const tourTitle = tour.name;
              const tourSlug = slugify(tourTitle);

              return {
                id: tour.tourUUID,
                title: tourTitle,
                slug: tourSlug,
                description: tour.description,
                images:
                  tour.cover_image_uri.startsWith("http://") ||
                  tour.cover_image_uri.startsWith("https://")
                    ? tour.cover_image_uri
                    : `${process.env.REACT_APP_API_BASE_URL}${tour.cover_image_uri}`,
                price: tour.priceMin,
                sprice: tour.stripe_price_id,
                duration: tour.duration,
                durations: Array.isArray(tour.durations) ? tour.durations : [],
                personsInsteadTime: Boolean(tour.uses_people_instead_of_times),
                usesPeopleAndTimesPricing: Boolean(
                  tour.uses_people_and_times_pricing
                ),
                uses_people_and_times_pricing: Boolean(
                  tour.uses_people_and_times_pricing
                ),
                preferLowerPeoplePriceTier: Boolean(
                  tour.prefer_lower_people_price_tier
                ),
                prefer_lower_people_price_tier: Boolean(
                  tour.prefer_lower_people_price_tier
                ),
                frontendUsesPeoplePriceTiers: Boolean(
                  tour.frontend_uses_people_price_tiers
                ),
                frontend_uses_people_price_tiers: Boolean(
                  tour.frontend_uses_people_price_tiers
                ),
                vehiclesSmall: Boolean(tour.show_vehicles_as_lowest_capacity),
              };
            });
            setTours(transformedTours);
            console.log("Transformed Tours i:", transformedTours);
          } else {
            console.error(
              "API response does not contain an array of tours:",
              response.data
            );
          }
        })
        .catch((error) => {
          console.log("catch");
          console.error("There was an error fetching the tours!", error);
        })
        .finally(() => {
          console.log("finally");
          setLoading(false);
        });
    }
    // console.log("realToken");
    // console.log(realToken);
    // console.log("tours");
    // console.log(tours);
  }, [
    tours,
    isAuthReady,
    token,
    axiosInstance,
    getListUrl,
    setTours,
    setLoading,
  ]);

  const [imageLoaded, setImageLoaded] = useState(false);

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  scrollToTop();

  // const showOverlayIframe = (tour) => {
  //   console.log("showOverlayIframe ->", tour);
  // };

  return (
    <div className="bodySelectTourList">
      <>
        {!imageLoaded && <SkeletonTourListPreload />}
        <GridContainer>
          {Array.isArray(tours) &&
            tours.length > 0 &&
            tours.map((tour, index) => (
              <BentoCard
                key={tour.id}
                tourState={tour}
                index={index}
                {...tour}
                onImagesLoad={handleImageLoad}
                imageLoaded={imageLoaded}
                isIframe={true}
              />
            ))}
        </GridContainer>
      </>
    </div>
  );
}

export default TourListIframe;
